import createQueryParams from './createQueryParams';
const createRequestPath = ({ protocol, host, params }, path) => {
    const pathWithoutQueryParam = `${host?.includes('0.0.0.0') ? 'http' : protocol}://${host}/${path}/`;
    const fullPath = `${pathWithoutQueryParam}${createQueryParams(params?.query)}`;
    return { fullPath, pathWithoutQueryParam };
};
export default createRequestPath;
